import React from "react";

const DogIcon: React.FC = () => {
    return (
        <svg version="1.1"
             xmlns="http://www.w3.org/2000/svg"
             x="0px" y="0px"
             viewBox="0 0 800 800"
             className="blj-store-locator__dog-icon"
        >
            <g id="Tail">
                <path
                    d="M598.7,532.4c95.5,35.4,122.8-2.8,122.8-2.8c-34.6,8.2-104.8-19-135.6-32C532.3,477.1,556.9,508.4,598.7,532.4z"></path>

            </g>
            <g id="Dog">
                <g>
                    <path d="M211.1,338.2c0-0.1,0-0.1,0-0.2C211.1,338,211.1,338.1,211.1,338.2z"></path>

                    <path d="M211.2,337.4c0-0.1,0-0.2,0.1-0.4C211.3,337.2,211.2,337.3,211.2,337.4z"></path>

                    <path d="M585.8,497.5c-31.7-46.7-108-47.3-108-47.3c-57.7-1.7-117.6,4.2-171.7-19.6c-16.4-7.2-35.3-16.6-48.1-29.2
			c-12.9-12.7-22.3-30.1-33.3-44.5c-4.5-5.8-8.9-11.7-14-17.1c-0.1,0.2-0.1,0.5-0.2,0.7c-2.3,7-5,13.7-8.7,20.1
			c-2.7,4.7-6.1,10.2-11,13.2c-5.8,3.4-10.2-0.9-12.8-5.7c-2.5-4.8-4.1-10.4-5.3-15.6c-0.9-3.6-2-7.4-2.7-11.1
			c0.4,1.4,0.8,2.9,1.2,4.2c1.4,5.2,3.1,10.8,5.9,15.7c2.8,4.9,7.7,9.2,14,5.9c5.4-2.9,9-8.4,12-13.1c3.4-5.4,5.9-11.1,8.2-16.9
			c0.5-3.8-0.3-7.8-3.6-10.5c-3.9-3.3-9.2-1.2-14.2-2.4c-0.7-0.2-1.3-0.4-2-0.6c-4.8-1.5-10.5-5.3-15.4-3.2
			c-0.2,0.1-0.4,0.2-0.5,0.2c-1.4,0.7-2.5,1.7-3.4,2.9c-6.7-0.2-13.4,0.2-19.8,0.5c-4.1,0.2-8.2,0.5-12.1,1.7
			c-3.9,1.2-7.6,3.4-10,6.7c-3,4.2-4.2,9.3-5.3,14.2c-1.1,5-1.2,8.3-6.1,11.1c-3.3,1.9-10.5,0.2-14.3,0.1c-0.6,0-1.2,0-1.8,0
			c-0.9-0.7-1.9-1.3-3.2-1.6c-2.2-0.5-4.7-0.7-6.9-0.6c-1.2,0-2.4,0.2-3.5,0.8c-3,1.6-3.7,5.6-3.9,8.6c-0.3,3.2-0.2,7.4,2.6,9.5
			c0.1,0.1,0.3,0.2,0.4,0.3c0,0.2,0,0.4,0,0.6c0,8,0,16.2,1.6,24.1c1.8,9.2,3.3,22.5,12.8,27.4c3.8,1.9,8.3,1.8,12.6,2
			c12.1,0.6,23.9,4.4,34.2,10.8c10.4,6.5,15.5,14.6,21.6,24.8c12.8,21.4,25,44.4,30.8,68.8c5,20.9,13.2,37.3,23.7,50
			c26.2,132.3-30.7,138.2-30.7,138.2c-16.9,7.4-13.5,24.3-13.5,24.3h43.3c28.6-22.2,42.2-53.2,48.3-82.8
			c13.6,54.4-13.4,58.5-13.4,58.5c-16.9,7.4-13.5,24.3-13.5,24.3h43.3c32.7-31.4,30-83.4,21.7-122.3c61.5,5.3,124.8-19.1,124.8-19.1
			c3.8-1.5,7.5-2.8,10.9-3.9c37.4,49.4,92.6,65.6,92.6,65.6c35.8,22.3,33.8,55.4,33.8,55.4c-16.9,7.4-11.6,24.3-11.6,24.3h46.8
			c3.3-33.4-5.5-60.8-14.2-78.8c6.2-0.2,10-0.9,10-0.9c43,12,33.8,55.4,33.8,55.4c-16.9,7.4-11.3,24.3-11.3,24.3h46.5
			c6.1-60.8-28.4-102-28.4-102c-63.7-12.9-48.2-71.2-48.2-71.2c3.3-15.2,3.9-28.5,2.5-40.2c0,0,0.1,0,0.1,0L585.8,497.5
			C585.8,497.5,585.8,497.5,585.8,497.5z"></path>

                    <path d="M585.9,497.5l12.8,34.9"></path>

                    <path d="M211.2,337.8c0-0.1,0-0.2,0-0.3C211.2,337.6,211.2,337.7,211.2,337.8z"></path>

                    <path
                        d="M210.8,339.3C210.8,339.3,210.8,339.3,210.8,339.3C210.8,339.3,210.8,339.3,210.8,339.3z"></path>

                    <path d="M211,338.5c0,0,0-0.1,0-0.1C211,338.5,211,338.5,211,338.5z"></path>

                    <path
                        d="M210.9,338.9C210.9,338.9,210.9,338.9,210.9,338.9C210.9,338.9,210.9,338.9,210.9,338.9z"></path>

                </g>
            </g>
        </svg>
    )
}

export default DogIcon;